exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fullscreen-preloader-layer[data-v-543e5658]{color:#fff;text-align:center;background:var(--bb-darkgrey);display:flex;flex-direction:column;align-items:center;justify-content:center;width:100vw;height:100vh}.preloader-logo[data-v-543e5658]{margin-bottom:30px;width:100px}", ""]);

// exports
